import { useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { useCookieConsent } from "../../modules/CookieConsent";
import { CONSENT_GATED_PATHS } from "../../modules/CookieConsent/constants";
import { analyticsService } from "../services/analyticsService";
import { postHogService } from "../services/postHogService";

export const useInitAnalytics = (
  isSessionSettled: boolean,
  accountId?: string
) => {
  const location = useLocation();
  const { hasDecision } = useCookieConsent();
  const [isReadyToLoad, setIsReadyToLoad] = useState(false);

  const isConsentGatedPath = !!matchPath(location.pathname, {
    path: [...CONSENT_GATED_PATHS]
  });

  useEffect(() => {
    let timeout = 0;

    if (isSessionSettled) {
      // We should wait before all redirects complete
      timeout = window.setTimeout(() => {
        setIsReadyToLoad(true);
      }, 500);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [isSessionSettled]);

  const canLoadAnalytics =
    hasDecision || (isReadyToLoad && !isConsentGatedPath);

  useEffect(() => {
    if (canLoadAnalytics) {
      analyticsService.load();
    }
  }, [canLoadAnalytics]);

  useEffect(() => {
    if (!isReadyToLoad || !canLoadAnalytics) {
      postHogService.reset();
      return;
    }

    postHogService.syncSessionReplay({ accountId });
  }, [canLoadAnalytics, isReadyToLoad, accountId]);
};
